import { useState, useCallback, useEffect } from 'react';
import { u as useIsMounted } from './hook-Bex3s64q.js';

const useFixedPosition = ({ locateElementRef, targetElementRef, rectCalculator, }) => {
    const isMounted = useIsMounted();
    const [positionRect, setPositionRect] = useState(null);
    const refreshRect = useCallback(() => {
        const { current: locateElement } = locateElementRef;
        const { current: targetElement } = targetElementRef;
        if (!locateElement || !targetElement) {
            return;
        }
        const { width, height } = targetElement.getBoundingClientRect();
        setPositionRect(rectCalculator(locateElement.getBoundingClientRect(), {
            width,
            height,
        }));
    }, [
        locateElementRef,
        targetElementRef,
        rectCalculator,
    ]);
    useEffect(() => {
        if (!isMounted) {
            return;
        }
        refreshRect();
    }, [
        isMounted,
        refreshRect,
    ]);
    useEffect(() => {
        const onWindowResize = () => {
            refreshRect();
        };
        window.addEventListener('resize', onWindowResize);
        return () => {
            window.removeEventListener('resize', onWindowResize);
        };
    }, [refreshRect]);
    return {
        rect: positionRect,
        refreshRect,
    };
};

export { useFixedPosition as u };
//# sourceMappingURL=hook-CckkA92z.js.map
